import { DialogButtons, DialogCustomButtonType, DialogResults, FormCustomAction } from '@msdk/common'

export class ResetToDefault extends FormCustomAction {
  dialogTitle = this.translate('UM_RESET_TO_DEFAULT_DIALOG_TITLE', 'Re-set to default')
  dialogDesc = this.translate(
    'UM_RESET_TO_DEFAULT_DIALOG_DESCR',
    'Are you sure you want to reset to default? The operation is irreversible, the page will be reloaded',
  )
  dialogBtnOk = this.translate('UM_RESET_TO_DEFAULT_BUTTON_OK', 'Re-set')
  dialogBtnCancel = this.translate('UM_ACTION_CONFIRMATION_CANCEL', 'Cancel')

  async onClick(): Promise<void> {
    const res = await this.dialogModal.createModal(this.dialogTitle, this.dialogDesc, DialogButtons.Custom, [
      {
        label: this.dialogBtnCancel,
        result: DialogResults.Cancel,
        type: DialogCustomButtonType.Secondary,
      },
      {
        label: this.dialogBtnOk,
        result: DialogResults.Yes,
        type: DialogCustomButtonType.Primary,
      },
    ])
    if (res === DialogResults.Yes) {
      this.resetToDefault()
    }
  }

  async resetToDefault() {
    await this.apiClient.entity
      .deleteEntity('CMPS', 'MEASUREMENT_UNIT', this.entity.id, 'MEASUREMENT_UNIT_FORM')
      .then(() => {})
  }

  isDisabled(): boolean {
    return false
  }

  isVisible(): boolean {
    return this.entity.IsPersisted
  }
}
